var exports = {
  "l": "starButton__uoPS7o",
};

module.exports = exports;
